module.exports = __webpack_public_path__ + "static/35-078108c64bd28affe31fc8e3fad891ce.jpg";